// extracted by mini-css-extract-plugin
export default {"rating":"Jx-z","numberOfStars":"Kx-z","count":"Lx-z","barGraphSpacing":"Mx-z","barGraph":"Nx-z"};